module.exports = __webpack_public_path__ + "img/p5_2.1acc032a.webp";